import React from 'react';
// import { useRouteNode } from 'react-router5';
import { withRouter } from 'react-router5';
import useSubscribeRouter from "../utils/useSubscribeRouter";
import Focus from '../focus/focus';
import Bookmark from '../bookmark/bookmark';
import ProfilUser from './profilUser.js';

function Profile({ router }) {
  const { route: {name, data} } = useSubscribeRouter(router);
  const [, subroot] = name.split('.');

  return (
    <div className="c-container_global">
      <section className="c-container container_one" style={{width: subroot ? "50%" : "100%", minHeight: "100%"}}>
        <ProfilUser users={data.users} dataList={data.profil} bookmarksInit={data.bookmarks} route={subroot === "undefined" ? "" : subroot}/>
      </section>
      { subroot === "focus" && <Focus /> }
      { subroot === "bookmark" && <Bookmark users={data.users} bookmarks={data.bookmarks} /> }
    </div>
  )
}

export default withRouter(Profile);
